module.exports = __webpack_public_path__ + "img/volume-max.5b26ab0f.svg";